export default __webpack_public_path__ + "static/media/assets.51622ae8.png";